import { page_not_found } from "assets";
import Footer from "Screens_old/Layout/Common/Components/Footer";
// import Navbar from "Screens_old/Layout/Common/Components/NavBar";

const PageNotFound = () => {

    return (
        <div className="d-flex flex-column justify-content-between" style={{minHeight: 100 + 'vh'}}>
            {/* <Navbar navbarClass="navbar-dark fixed-top" /> */}
            <div className="d-flex flex-column justify-content-center align-items-center m-5">
                <div className="d-flex flex-column justify-content-center align-items-center p-5" style={{
                    borderRadius: 8,
                    background: "#FFF",
                    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                    width: "70%",
                    maxWidth: "1079px;"
                }}>
                    <img src={page_not_found} alt="Page does not exist" className="w-100" style={{maxWidth: "484px"}}/>
                    <h4 className="page-not-found-text text-center">Page not found</h4>
                    <a style={{ padding: "14px 20px", fontSize: 14 }} className="btn btn-primary btn-lg mt-3" href="/">Go To Home</a>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default PageNotFound;